/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
import { copyPropertyIfDefined, fail } from './Common';
import { convertTreeNodes } from './EditUtilities';
import { isDetachedSequenceId } from './Identifiers';
import { ChangeTypeInternal, } from './persisted-types';
export function convertEditIds(edit, convert) {
    const changes = edit.changes.map((change) => {
        switch (change.type) {
            case ChangeTypeInternal.Build:
                return {
                    type: ChangeTypeInternal.Build,
                    destination: change.destination,
                    source: change.source.map((tree) => {
                        return convertTreeNodes(tree, (node) => convertNodeDataIds(node, convert), isDetachedSequenceId);
                    }),
                };
            case ChangeTypeInternal.Insert:
                return {
                    type: ChangeTypeInternal.Insert,
                    source: change.source,
                    destination: convertStablePlaceIds(change.destination, convert),
                };
            case ChangeTypeInternal.Detach: {
                const detach = {
                    type: ChangeTypeInternal.Detach,
                    source: convertStableRangeIds(change.source, convert),
                };
                copyPropertyIfDefined(change, detach, 'destination');
                return detach;
            }
            case ChangeTypeInternal.SetValue:
                return {
                    type: ChangeTypeInternal.SetValue,
                    nodeToModify: convert(change.nodeToModify),
                    payload: change.payload,
                };
            case ChangeTypeInternal.Constraint: {
                const constraint = {
                    type: ChangeTypeInternal.Constraint,
                    effect: change.effect,
                    toConstrain: convertStableRangeIds(change.toConstrain, convert),
                };
                copyPropertyIfDefined(change, constraint, 'identityHash');
                copyPropertyIfDefined(change, constraint, 'label');
                copyPropertyIfDefined(change, constraint, 'length');
                copyPropertyIfDefined(change, constraint, 'contentHash');
                if (change.parentNode !== undefined) {
                    constraint.parentNode = convert(change.parentNode);
                }
                return constraint;
            }
            default:
                fail('Unknown change type.');
        }
    });
    const newEdit = { id: edit.id, changes };
    copyPropertyIfDefined(edit, newEdit, 'pastAttemptCount');
    return newEdit;
}
export function convertNodeDataIds(nodeData, convert) {
    const identifier = convert(nodeData.identifier);
    const output = { definition: nodeData.definition, identifier };
    copyPropertyIfDefined(nodeData, output, 'payload');
    return output;
}
export function convertStableRangeIds(range, convert) {
    const start = convertStablePlaceIds(range.start, convert);
    const end = convertStablePlaceIds(range.end, convert);
    return { start, end };
}
export function convertStablePlaceIds({ side, referenceSibling, referenceTrait }, convert) {
    const stablePlaceNew = {
        side,
    };
    if (referenceSibling !== undefined) {
        const nodeId = convert(referenceSibling);
        stablePlaceNew.referenceSibling = nodeId;
    }
    if (referenceTrait !== undefined) {
        const parent = convert(referenceTrait.parent);
        stablePlaceNew.referenceTrait = {
            label: referenceTrait.label,
            parent,
        };
    }
    return stablePlaceNew;
}
//# sourceMappingURL=IdConversion.js.map